<template>
  <div :style="themeStyle" v-if="level">
    <v-row no-gutters class="headline2_bg card">
        <v-col class="text-center cardbg">
            <span style="position:absolute;top:25px;right:20px;z-index:10;" class="bold">
                <v-chip
                    class="ma-2"
                    color="#dddddd"
                    >
                    {{level.name}}
                </v-chip>
            </span>
            <v-container class="pt-6">
            <v-fade-transition mode="out-in">
                <v-img :src="level.pictureUrl" max-height="200"></v-img>
            </v-fade-transition>
        </v-container>
    </v-col>
    </v-row>
    <v-container class="pa-6">
        <v-row v-if="member">
            <v-col class="headline2 font45 weight1000 text-center pa-0 coin_icon_medium">{{formatNumber(member.currentPoint)}}</v-col>
        </v-row>
        <v-row>
            <v-col class="headline1 font18 bold text-center pt-0 pb-7">คะแนนทั้งหมด</v-col>
        </v-row>
        <v-row>
            <v-col class="headline1 font16 bold">สิทธิประโยชน์</v-col>
        </v-row>
        <v-row>
            <v-col><nl2br tag="p" :text="level.priviledge"/></v-col>
        </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuItem from '../../MenuItem'
export default {
  name: 'Card',
  components: {
    'menu-item': MenuItem
  },
  data () {
    return {
      member: null,
      level: null,
      nextlevel: null
      // profile: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    await this.prepareData()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async prepareData () {
      this.member = this.GET_MEMBERINFO()
      // this.profile = this.getLiffProfile()
      await this.getLevelDB()
      this.level = await this.getLevel()
      // this.level = await this.getLevel()
      // this.member = await this.getMemberInfo()
      this.level.sort((a, b) => { return b.point - a.point })
      this.level.map((row) => {
        if (this.member.totalPoint < row.point) {
          this.nextlevel = row
        }
      })
      this.level = this.level.filter((item) => parseInt(item.levelId) === parseInt(this.member.levelId))[0]
    }
  }
}
</script>
<style scoped>
.card {
    height: 200px;
    overflow:hidden;
}
.cardbg {
    background-repeat: no-repeat !important;
    background-size: 90% 110% !important;
    background-attachment: fixed;
    background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/C/Privilege.vue